// Discovery Parks booking strategy.
//
// A site's reserveUrl is the category's own page on
// discoveryholidayparks.com.au (/caravan-parks/{state}/{region}/{park}/
// {category}). The page takes the stay and the party in its query string
// (`arrive`, `depart` as YYYY-MM-DD, `adults`, `kids`, `infants`) and opens
// with them filled in: the quote with Add Stay, or the park's own refusal
// ("No availability during these dates"). It ignores `checkIn`/`checkOut`
// and falls back to today.

import { format } from "date-fns";
import { resolveCheckout } from "./_context.js";

const isoDate = (date) => format(date, "yyyy-MM-dd");

// The booking panel's own default party.
const DEFAULT_ADULTS = 2;

export default {
  buildBookingUrl(ctx) {
    const { site, arrivalDate, partySize } = ctx;
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.searchParams.set("arrive", isoDate(arrivalDate));
    url.searchParams.set("depart", isoDate(resolveCheckout(ctx)));
    url.searchParams.set("adults", String(partySize ?? DEFAULT_ADULTS));
    url.searchParams.set("kids", "0");
    url.searchParams.set("infants", "0");
    return url.toString();
  },

  // The park's page lists every category the park sells; the reserveUrl is
  // one category's page.
  buildPreviewUrl(site) {
    const url = new URL(site.reserveUrl);
    url.search = "";
    url.pathname = url.pathname.replace(/\/[^/]+\/?$/, "");
    return url.toString();
  },

  describeBookingInputs() {
    return {
      inputs: {
        arrivalDate: {
          status: "required",
          notes: "Encoded as ?arrive=<yyyy-MM-dd>.",
        },
        departureDate: {
          status: "required",
          notes:
            "Encoded as &depart=<yyyy-MM-dd>; resolved from arrival + minStayLength when not supplied.",
        },
        ref: {
          status: "ignored",
          notes: "site.reserveUrl already is the category's page.",
        },
        partySize: {
          status: "defaulted",
          defaultValue: DEFAULT_ADULTS,
          notes:
            "Encoded as &adults=<N> with kids=0; the booking panel's default is 2 adults.",
        },
      },
    };
  },
};
